import Vue from 'vue'
import Router from 'vue-router'

const login = () => import('../views/login/login');
const content = () => import('../layout');
const home = () => import('../views/home-page/home-page'); //首页

//车型管理start
const car_series = () => import('../views/car_manage/car_series'); //车系
const car_group = () => import('../views/car_manage/car_group'); //车组
const car_kind = () => import('../views/car_manage/car_kind'); //车型
const car_kind_file = () => import('../views/car_manage/car_kind_file'); //车型文件
const car_icon = () => import('../views/car_manage/car-icon'); //车标类型
const car_iconFile = () => import('../views/car_manage/car-iconFile'); //车标文件
const equip_model = () => import('../views/car_manage/equip_model'); //已授权售机类型
const equip_model1 = () => import('../views/car_manage/equip_model1'); //未授权售机类型
const sellingType = () => import('../views/car_manage/sellingType'); //售机类型

const car_version = () => import('../views/car_manage/car_version'); //车型版本
const car_lang_version = () => import('../views/car_manage/car_lang_version'); //车型语言版本
//车型管理end


//设备start
// const equip_model = () => import('../components/content/equip-manage/equip-model'); //设备机型
// const authorized_equip = () => import('../components/content/productInfoPage/authorized-equip'); //设备机型的授权车型
// const unauthorized_equip = () => import('../components/content/productInfoPage/unauthorized-equip'); //设备机型的未授权车型
const user_equip = () => import('../views/equip-manage/user-equip/index.vue'); //用户设备
const empowerRegion = () => import('../views/equip-manage/user-equip/empowerRegion/index.vue'); //用户设备
// const user_unauthorized = () => import('../components/content/equip-manage/user-equip/unauthorized-region.vue'); //用户设备
// const user_authorized = () => import('../components/content/equip-manage/user-equip/authorized-region.vue'); //用户设备
const mobile_equip = () => import('../views/equip-manage/mobile-equip/index.vue'); //手机设备
const intelligent_key = () => import('../views/equip-manage/intelligent-key/index.vue'); //智能钥匙
const clientLogProductlog = () => import('../views/equip-manage/clientLogProductlog/index.vue'); //手机设备
const mainRecord = () => import('../views/equip-manage/mainRecord/index.vue'); //维修记录
const nosnVCI = () => import('../views/equip-manage/nosnVCI/index.vue'); //未写序列号设备
const motorcycle = () => import('../views/equip-manage/motorcycle/index.vue'); //vci与平板
const bindrecord = () => import('../views/equip-manage/motorcycle/bindrecord.vue'); //vci与平板绑定记录
const bindrelease = () => import('../views/equip-manage/motorcycle/bindrelease.vue'); //vci与平板绑定关系
const changemachine = () => import('../views/equip-manage/changemachine/index.vue'); //换机数据
const clientLogProduct = () => import('../views/equip-manage/clientLogProduct/index.vue'); //设备序列号过期日期修改记录
//设备end

//商用车start
const model_dataPackage = () => import('../views/commercial-car/model-dataPackage'); //商用车
//商用车end

//拓展包start
const file_info = () => import('../views/expand-package/file-info'); //文件信息
const file_version = () => import('../views/expand-package/file-version'); //文件版本
//拓展包end

//通用文件
const file_language = () => import('../views/file-manage/file-language'); //文件类型语言信息
const file_type = () => import('../views/file-manage/file-type'); //文件类型
const file_ver = () => import('../views/file-manage/file-version'); //文件版本
const children_ver = () => import('../views/file-manage/children-version'); //子文件版本
const file_upgrade = () => import('../views/file-manage/file-upgrade'); //文件类型版本升级说明

//海外通用
const brand_list = () => import('../views/overseas-manage/brand-list'); //品牌列表
// const authorized_brand = () => import('../components/content/equip-manage/authorized-brand'); //品牌列表
// const unauthorized_brand = () => import('../components/content/equip-manage/unauthorized-brand'); //品牌列表

const salesArea = () => import('../views/foreignIP-monitoring/sales-area.vue'); //品牌列表
const exceptionAccess = () => import('../views/foreignIP-monitoring/exception-access.vue'); //品牌列表

const lockMachineManagement = () => import('../views/lockMachine-management'); //锁机列表
const userManagement = () => import('../views/user-management'); //用户列表
const operationLog = () => import('../views/operation-log'); //操作日志
const ECUcode = () => import('../views/ECU-code'); //ECU故障码
const commapptype = () => import('../views/commapptype'); //通用应用设备
const salerManagement = () => import('../views/saler-management'); //业务员（销售员）列表
const nationalityManagement = () => import('../views/nationality-management'); //国家列表
const memberManagement = () => import('../views/member-management'); //注册用户列表
const fengHuiUsers = () => import('../views/fengHuiUsers'); //丰汇用户列表
const privateContract = () => import('../views/privateContract'); //私有协议
const privateContract_add = () => import('../views/privateContract/privateContract_add.vue'); //私有协议
const privateContract_update = () => import('../views/privateContract/privateContract_update.vue'); //私有协议
const dllcallSet = () => import('../views/dllcallSet'); //DLL调用设置
const DllCallInfo = () => import('../views/dllcallSet/DllCallInfo'); //DLL算法验证码列表
const DllcallRec = () => import('../views/dllcallSet/DllcallRec'); //DLL调用记录
const downRegionManagement = () => import('../views/downRegion-management'); //下载区域列表
const languageManagement = () => import('../views/language-management'); //语言列表
const productclassManagement = () => import('../views/productclass-management'); //产品列表
const orderManagement = () => import('../views/order-management'); //订单列表
const serialNumManagement = () => import('../views/order-management/serialNum-management'); //订单列表
const productFunction = () => import('../views/product-function'); //订单列表
const userUploadPage = () => import('../views/userUploadPage'); //上传数据包
const carAlarmPage = () => import('../views/ecuSafe/carAlarmPage'); //安全算法和故障码调用告警
const carRecPage = () => import('../views/ecuSafe/carRecPage'); //安全算法调用记录
const ecu_menu = () => import('../views/ecu_menu'); //ecu管理
const dialog_menu = () => import('../views/ecu_menu/dialog_menu'); //ecu管理
const dialog_menu_child = () => import('../views/ecu_menu/dialog_menu_child'); //ecu管理
const instruction_group = () => import('../views/ecu_menu/instruction_group'); //ecu管理
const instruction_list = () => import('../views/ecu_menu/instruction_list'); //ecu管理
const faultinfo = () => import('../views/ecu_menu/faultinfo'); //ecu管理
const ecuscantype = () => import('../views/ecu_menu/ecuscantype'); //ecu管理
const ecuscantyperesult = () => import('../views/ecu_menu/ecuscantyperesult'); //ecu管理
const logSearch = () => import('../views/ecu_menu/logSearch'); //ecu管理

const hardListManagement = () => import('../views/hardList-management'); //配置清单列表
const productInfoPage = () => import('../views/equip-manage/productInfoPage'); //配置清单列表
const uiScheme = () => import('../views/equip-manage/uiScheme/index'); //配置清单列表
const empowerManagement = () => import('../views/equip-manage/productInfoPage/empowerManagement'); //配置清单列表
const productActivelog = () => import('../views/productActivelog/index'); //国内投诉列表
const serialNumberManage = () => import('../views/serialNumberManage/index'); //测试白名单
const ecuOperate = () => import('../views/ecuOperate/index'); //测试白名单
const vehicleSn = () => import('../views/vehicleSn/index'); //测试白名单

// F8 Pro系统管理
const f8_carbrand = () => import('../views/F8-Pro/f8_carbrand.vue'); //汽车品牌列表
const f8_carkind = () => import('../views/F8-Pro/f8_carkind.vue'); //车型列表
const f8_sensortype = () => import('../views/F8-Pro/f8_sensortype.vue'); //传感器类型
const f8_reference = () => import('../views/F8-Pro/f8_reference.vue'); //参考值
const f8_sensorBrand = () => import('../views/F8-Pro/f8_sensorBrand.vue'); //传感器品牌
const f8_sensor = () => import('../views/F8-Pro/f8_sensor.vue'); //传感器
const f8_reviewUploaded = () => import('../views/F8-Pro/f8_reviewUploaded.vue'); //车型列表
const commercial_vehicles = () => import('../views/commercial-mange/commercial_vehicles.vue'); //车型列表
const commercial_vehiclesFile = () => import('../views/commercial-mange/commercial_vehiclesFile.vue'); //车型列表
const cvgroup_page = () => import('../views/commercial-mange/cvgroup_page.vue'); //车型列表

// 投诉管理
const logDecrypt = () => import('../views/appeal-mange/logDecrypt'); //海外投诉列表
const appeal_inland = () => import('../views/appeal-mange/appeal-inland'); //海外投诉列表
const appeal_ZD = () => import('../views/appeal-mange/appeal-ZD'); //智断投诉列表
const appeal_cando = () => import('../views/appeal-mange/appeal-cando'); //cando投诉列表
const appeal_fh = () => import('../views/appeal-mange/appeal-fh'); //丰汇投诉列表
const appeal_ljlc = () => import('../views/appeal-mange/appeal-ljlc'); //路检路查列表
const appeal_oversea = () => import('../views/appeal-mange/appeal-oversea'); //国内投诉列表
const appeal_detail = () => import('../views/appeal-mange/components/appeal_detail'); //国内投诉列表
const diagnosisapply = () => import('../views/diagnosisapply/index.vue'); //国内投诉列表
const padregistrec = () => import('../views/diagnosisapply/padregistrec.vue'); //国内投诉列表

/*3D*/
const equipment_3d = () => import('../views/3d-pay/equipment'); //设备管理
const abnormalAuthorization_3d = () => import('../views/3d-pay/abnormalAuthorization'); //异常权限
const order_3d = () => import('../views/3d-pay/order'); //订单管理
const unitPrice_3d = () => import('../views/3d-pay/unitPrice'); //套餐单价
const user_3d = () => import('../views/3d-pay/user'); //用户管理
const numerical = () => import('../views/5d/numerica'); //用户管理
const repairsApproval = () => import('../views/3d-pay/repairsApproval'); //故障报修审批
const carkindfuncPage = () => import('../views/car_manage/carkindfuncPage'); //故障报修审批
const authorizationCode = () => import('../views/3d-pay/authorizationCode'); //设备授权码生成

// F9s
const userList = () => import('../views/F9s-inland/userList'); // 用户列表
const carCheck = () => import('../views/F9s-inland/carCheck'); //诊断记录
const checkDetail = () => import('../views/F9s-inland/carCheck-detail'); //诊断详情
const checkDetail2 = () => import('../views/F9s-overseas/carCheck-detail'); //诊断详情
const carInfo = () => import('../views/F9s-inland/carInfo'); //车辆列表
// F9s
const userList2 = () => import('../views/F9s-overseas/userList'); // 用户列表
const carCheck2 = () => import('../views/F9s-overseas/carCheck'); //诊断记录
const carInfo2 = () => import('../views/F9s-overseas/carInfo'); //车辆列表

// ZD618
const ZD618Management = () => import('../views/ZD618Management/index'); //车辆列表
const ZD618Management_track = () => import('../views/ZD618Management/track'); //行程列表
const ZD618Management_brand = () => import('../views/ZD618Management/brand'); //行程列表
const ZD618Management_carowner = () => import('../views/ZD618Management/carowner'); //车主列表
const ZD618Management_device = () => import('../views/ZD618Management/device'); //用户设备列表


const e8 = () => import('../views/e8'); //故障报修审批

// 商用车在线菜单
const dieselecu = () => import('../views/online-menu/dieselecu'); //商用车ECU
const dieselecutype = () => import('../views/online-menu/dieselecutype'); //商用车ECU类型
const carsystem = () => import('../views/online-menu/carsystem'); //车型系统菜单
const dieselbrand = () => import('../views/online-menu/dieselbrand'); //商用车品牌
const dieseldata = () => import('../views/online-menu/dieseldata'); //商用车数据
const dieselgroup = () => import('../views/online-menu/dieselgroup'); //商用车车组
const sysmenulink = () => import('../views/online-menu/sysmenulink'); //车型系统菜单关系
const brandicon = () => import('../views/online-menu/brandicon'); //品牌图标
const dieselbrandmenu = () => import('../views/online-menu/dieselbrandmenu'); //品牌系统菜单
const menupackbrand = () => import('../views/online-menu/menupackbrand'); //菜单数据包
const authManage = () => import('../views/online-menu/menupackbrand/authManage'); //菜单数据包授权管理品牌
const authProduct = () => import('../views/online-menu/menupackbrand/authProduct'); //菜单数据包授权管理品牌
const authSystem = () => import('../views/online-menu/menupackbrand/authSystem'); //菜单数据包授权管理系统菜单
const menupackgroup = () => import('../views/online-menu/menupackbrand/menupackgroup'); //菜单数据包车组
const dieselgroupbrand = () => import('../views/online-menu/dieselgroupbrand'); //车组品牌
const entrymask = () => import('../views/online-menu/entrymask'); //进入功能描述
const polyphoneword = () => import('../views/online-menu/polyphoneword'); //多音字词组
const buildfile = () => import('../views/online-menu/buildfile'); //商用车菜单数据生成库文件

let name5d = sessionStorage.getItem('en') ? 'Push Compensation Calibration' : '推车校正'

Vue.use(Router);
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: "/login",
      hidden: true,
    },
    {
      path: '/login',
      component: login,
      hidden: true,
    },
    {
      path: '/',
      name: '',
      leaf: true, //识别只有一个节点
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'home',
      children: [
        { path: '/home', component: home, name: sessionStorage.getItem('en') ? 'Home' : '首页', }
      ]
    },
    {
      path: '/',
      name: '5D',
      component: content,
      limit: 'tcjz',
      iconCls: 'el-icon-menu',
      children: [
      {
        path: '/5d/numerical',
        name: sessionStorage.getItem('en') ? 'Push Compensation Calibration' : '推车校正',
        limit: 'tcjz',
        component: numerical
      }, ]
    },
    {
      path: '/',
      name: '3D定位仪管理系统',
      component: content,
      limit: 'pay3d',
      iconCls: 'el-icon-menu',
      children: [
      {
        path: '/pay3D/user_3d',
        name: '用户管理',
        limit: 'pay3dUser_3d:list',
        component: user_3d
      },
      {
        path: '/pay3D/equipment_3d',
        name: '设备管理',
        limit: 'pay3dEquipment:list',
        component: equipment_3d
      },
      {
        path: '/pay3D/abnormalAuthorization_3d',
        name: '异常授权记录',
        limit: 'pay3dAbnormalAuthorization:list',
        component: abnormalAuthorization_3d
      },
      {
        path: '/pay3D/order_3d',
        limit: 'pay3dAbnormalAuthorization:list',
        name: '订单记录',
        component: order_3d
      },
      {
        path: '/pay3D/unitPrice_3d',
        name: '套餐单价管理',
        limit: 'pay3dUnitPrice:list',
        component: unitPrice_3d
      },
      {
        path: '/pay3D/repairsApproval',
        limit: 'pay3dRepairsApproval:list',
        name: '故障报修审批',
        component: repairsApproval
      }, 
      {
        path: '/pay3D/authorizationCode',
        limit: 'genRegistCode',
        name: '设备授权码生成',
        component: authorizationCode
      }, 
    ]
    },
    {
      path: '/',
      name: '远程诊断管理',
      component: content,
      limit: 'diagnosis',
      iconCls: 'el-icon-menu',
      children: [
      {
        path: '/diagnosisapply',
        name: '远程诊断申请列表',
        limit: 'diagnosis-apply:list',
        component: diagnosisapply
      },
      {
        path: '/padregistrec',
        name: '诊断平板列表',
        limit: 'diagnosis-padregistrec:list',
        component: padregistrec
      }, ]
    },
    {
      path: '/',
      name: '国内商用车管理',
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'chinaCvManage',
      children: [
      {
        path: '/commercial-mange/cvgroup-page',
        name: '商用车组',
        limit: 'chinaCvgroup_page:list',
        component: cvgroup_page
      },
      {
        path: '/commercial-mange/commercial-vehicles',
        name: '商用车型',
        limit: 'chinaCommercialVehicles:list',
        component: commercial_vehicles
      },
      {
        path: '/commercial-mange/commercial-vehiclesFile',
        name: '商用车型文件',
        limit: 'chinaCommercialVehiclesFile:list',
        component: commercial_vehiclesFile
      }, ]
    },
    {
      path: '/',
      name: '海外商用车管理',
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'overseasCarManage',
      children: [
      {
        path: '/overseas-manage/brand_list',
        name: '车型列表',
        limit: 'overseasCarManageBrand:list',
        component: brand_list
      }, ]
    },
    {
      path: '/',
      name: '车型管理',
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'carManage',
      children: [
        {
          limit: 'carManageSeries:list',
          path: '/car_manage/car_series',
          name: '车系',
          component: car_series,
        },
        {
          limit: 'carManageGroup:list',
          path: '/car_manage/car_group',
          name: '车组',
          component: car_group,
        },
        {
          limit: 'carManageKind:list',
          path: '/car_manage/car_kind',
          name: '车型',
          component: car_kind,
        },
        {
          limit: 'carManagekindFile:list',
          path: '/car_manage/car_kind_file',
          name: '车型文件',
          component: car_kind_file,
        },
        {
          limit: 'carManageKindData',
          path: '/car_manage/car_version',
          name: '车型版本',
          component: car_version,
        },
        {
          limit: 'carManageKindDataLang:list',
          path: '/car_manage/car_lang_version',
          name: '车型语言版本',
          component: car_lang_version,
        },
        {
          limit: 'carManageCarkindfuncPage:list',
          path: '/car_manage/carkindfuncPage',
          name: '车型功能菜单',
          component: carkindfuncPage
        },
        {

          limit: 'carManageIcon:list',
          path: '/car_manage/car_icon',
          name: '车标类型',
          component: car_icon,
        },
        {
          limit: 'carManageiconFile:list',
          path: '/car_manage/car_iconFile',
          name: '车标文件',
          component: car_iconFile
        },
        {
          limit: 'carManageiconFile:list',
          path: '/car_manage/equip_model',
          name: '已授权售机类型',
          hidden: true,
          component: equip_model
        },
        {
          limit: 'carManageiconFile:list',
          path: '/car_manage/equip_model1',
          name: '未授权售机类型',
          hidden: true,
          component: equip_model1
        },
        {
          limit: 'carManageiconFile:list',
          path: '/car_manage/sellingType',
          name: '售机类型',
          hidden: true,
          component: sellingType
        },

      ]
    },
    {
      path: '/',
      name: '商用车',
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'commercialVehicle',
      children: [
        {
          limit: 'commercialVehicleDataPackage:list',
          path: '/commercial-car/model_dataPackage',
          name: '车型数据包',
          component: model_dataPackage
        },

      ]
    },
    {
      path: '/',
      name: '拓展包',
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'expandPackage',
      children: [
      {
        path: '/expand-package/file_info',
        name: '文件信息',
        limit: 'expandPackageFileInfo:list',
        component: file_info
      },
      {
        limit: 'expandPackageFileVersion:list',
        path: '/expand-package/file_version',
        name: '文件版本',
        component: file_version
      }, ]
    },
    {
      path: '/',
      name: '通用文件',
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'fileManage',
      children: [
        {
          path: '/file-manage/file_type',
          name: '文件类型',
          component: file_type,
          limit: 'fMfileType:list',
        },
        {
          path: '/file-manage/file_ver',
          name: '文件版本',
          limit: 'fMfileVer:list',
          component: file_ver
        },
        {
          path: '/file-manage/children_ver',
          name: '子文件版本',
          limit: 'fMchildrenVer:list',
          component: children_ver
        },
        {
          path: '/file-manage/file_language',
          name: '语言信息',
          limit: 'fMfileLanguage:list',
          component: file_language
        },
        {
          path: '/file-manage/file_upgrade',
          name: '文件类型版本升级说明',
          limit: 'fMfileTypeVerLog:list',
          component: file_upgrade
        },

      ]
    },

    {
      path: '/',
      name: '海外IP监控',
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'foreignIPMonitoring',
      children: [
        /*{
          path: '/foreignIP-monitoring/sales_area',
          name: '经销商销售区域管理',
          component: salesArea
        },*/
        {
          path: '/foreignIP-monitoring/exception-access',
          name: '设备异常访问记录管理',
          component: exceptionAccess,
          limit: 'fMExceptionAccess:list',
        },
      ]
    },

    {
      path: '/',
      name: '投诉管理',
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'appealMange',
      children: [
      {
        path: '/appeal-mange/appeal-oversea',
        name: '海外投诉',
        component: appeal_oversea,
        limit: 'appealMangeOversea:list',
        meta: {
          // keepAlive: true
        },
      },
      {
        path: '/appeal-mange/appeal-inland',
        name: '国内投诉',
        component: appeal_inland,
        limit: 'appealMangeInland:list',
        meta: {
          // keepAlive: true
        },
      },
      {
        path: '/appeal-mange/appeal-ZD',
        name: '智断投诉',
        component: appeal_ZD,
        limit: 'appealMangeInland:list',
        meta: {
          // keepAlive: true
        },
      },
      {
        path: '/appeal-mange/appeal-cando',
        name: 'Cando投诉',
        component: appeal_cando,
        limit: 'appealMangeOversea:list',
        meta: {
          // keepAlive: true
        },
      },
      {
        path: '/appeal-mange/appeal-fh',
        name: '丰汇投诉',
        component: appeal_fh,
        limit: 'appealMangeInland:list',
        meta: {
          // keepAlive: true
        },
      },
      {
        path: '/appeal-mange/appeal-ljlc',
        name: '路检路查',
        component: appeal_ljlc,
        limit: 'appealMangeljlc:list',
        meta: {
          // keepAlive: true
        },
      },
      {
        path: '/appeal-mange/logDecrypt',
        name: '日志解密',
        component: logDecrypt,
        limit: 'appealMange:logDecrypt',
        meta: {
          // keepAlive: true
        },
      },
      {
        path: '/appeal-mange/appeal-detail',
        // path: '/appeal-mange/appeal-detail/:id',
        name: 'appeal_detail',
        component: appeal_detail,
        hidden: true,
      }, ]
    },
    {
      path: '/',
      name: '设备管理',
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'deviceManagement',
      children: [
      {
        limit: 'productInfoPageManagement:list',
        path: '/productInfoPage-management',
        name: '售机类型',
        component: productInfoPage,
        meta: {
          keepAlive: true
        },
      },
      {
        limit: 'ProductUiMgr:list',
        path: '/uiScheme',
        name: '设备UI方案',
        component: uiScheme,
        meta: {
          keepAlive: true
        },
      },
      {
        path: '/equip-manage/user_equip',
        name: '设备序列号',
        component: user_equip,
        meta: {
          keepAlive: true
        },
        limit: 'userEquip:list',
      },
      {
        path: '/equip-manage/mobile_equip',
        name: '手机设备序列号',
        component: mobile_equip,
        limit: 'mobileEquip:list',
      },
      {
        path: '/equip-manage/intelligent_key',
        name: '智能钥匙序列号',
        component: intelligent_key,
        limit: 'digitalkey_sn',
      },
      {
        path: '/clientLogProductlog',
        name: 'clientLogProductlog',
        component: clientLogProductlog,
        hidden: true,
      },
      {
        path: '/mainRecord',
        name: 'mainRecord',
        component: mainRecord,
        hidden: true,
      },
      {
        limit: 'productActivelog:list',
        path: '/productActivelog',
        name: '设备激活记录',
        component: productActivelog,
      },
      {
        limit: 'test_device',
        path: '/serialNumberManage',
        name: '测试白名单',
        component: serialNumberManage,
      },
      {
        limit: 'userEquip:pbreakruleslist',
        path: '/ecuOperate',
        name: '设备ECU违规操作',
        component: ecuOperate,
      },
      {
        limit: 'CjProductinfoMgr:list',
        path: '/vehicleSn',
        name: '车检序列号',
        component: vehicleSn,
      },
      {
        path: '/equip-manage/user_equip/empowerRegion',
        name: 'empowerRegion',
        component: empowerRegion,
        hidden: true,
      },
      {
        limit: 'appealMange:list',
        path: '/productInfoPage/empower-management',
        name: '授权管理',
        component: empowerManagement,
        hidden: true,
      }, 
      {
        limit: 'productVci:page',
        path: '/nosnVCI',
        name: '未写序列号设备',
        component: nosnVCI,
        // hidden: true,
      }, 
      {
        limit: 'vcipad_page',
        path: '/motorcycle',
        name: 'VCI与平板',
        component: motorcycle,
        // hidden: true,
      }, 
      {
        limit: 'vcipad_page',
        path: '/bindrecord',
        name: 'vci与平板绑定记录',
        component: bindrecord,
        hidden: true,
      }, 
      {
        limit: 'vcipad_page',
        path: '/bindrelease',
        name: 'vci与平板绑定关系',
        component: bindrelease,
        hidden: true,
      }, 
      {
        limit: 'changeMachine_page',
        path: '/changemachine',
        name: '换机数据',
        component: changemachine,
        // hidden: true,
      }, 
      {
        limit: 'userEquip:queryExpirePage',
        path: '/clientLogProduct',
        name: '过期日期修改记录',
        component: clientLogProduct,
        // hidden: true,
      }, 
    ]
    },
    {
      path:'/',
      name:'ECU刷写',
      component:content,
      // leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'ecuBrushMgr',
      children:[
        {
          path: '/userUploadPage',
          name: '上传数据包',
          limit: 'ecuBrushMgrUserUpload:list',
          component: userUploadPage,
          meta: {
            keepAlive: true
          },
        },
        {
          path: '/carAlarmPage',
          name: '安全算法和故障码调用告警',
          limit: 'ecusafeMgr:carAlarmPage',
          component: carAlarmPage,
          meta: {
            keepAlive: true
          },
        },
        {
          path: '/carRecPage',
          name: '安全算法调用记录',
          limit: 'ecusafeMgr:carRecPage',
          component: carRecPage,
          meta: {
            keepAlive: true
          },
        },
      ]
    },
    {
      path: '/',
      name: '卡巴驿家管理',
      component: content,
      // leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'kmemberinfoMgr',
      children: [
      {
        path: '/userManagement',
        name: '用户管理',
        component: userManagement,
        limit: 'kmemberinfoMgr:list'
      },
      {
        path: '/operationLog',
        name: '操作日志',
        component: operationLog,
        limit: 'sysoptlogMgr:list'
      },
      {
        path: '/ECUcode',
        name: 'ECU故障码',
        component: ECUcode,
        limit: 'ecusafeMgr:list'
      },
      {
        path: '/commapptype',
        name: '通用应用',
        component: commapptype,
        limit: 'commapptype:page'
      },
     ]
    },
    {
      path: '/',
      name: 'ZD618管理',
      component: content,
      // leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'zd618Sys:mgr',
      children: [
        {
          path: '/ZD618Management',
          name: '车辆列表',
          component: ZD618Management,
          limit:'zd618Sys:clientcarPage'
        }, 
        {
          path: '/ZD618Management_track',
          name: '行程列表',
          component: ZD618Management_track,
          limit:'zd618Sys:zdtripPage'
        }, 
        {
          path: '/ZD618Management_brand',
          name: '品牌列表',
          component: ZD618Management_brand,
          limit:'zd618Sys:carbrandPage'
        }, 
        {
          path: '/ZD618Management_carowner',
          name: '车主列表',
          component: ZD618Management_carowner,
          limit:'zd618Sys:zdcarownerPage'
        }, 
        {
          path: '/ZD618Management_device',
          name: '用户设备列表',
          component: ZD618Management_device,
          limit:'zd618Sys:zddevicePage'
        }, 
      ]
    },
    {
      path: '/',
      name: '云诊断',
      component: content,
      // leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'cloud_diagnosis',
      children:[
        {
          path: '/ecu_menu',
          name: 'ECU管理',
          component: ecu_menu,
          limit:'ecu_manage'
        },
        {
          path: '/dialog_menu',
          name: 'ECU管理',
          component: dialog_menu,
          hidden: true,
        },
        {
          path: '/dialog_menu_child',
          name: 'ECU管理',
          component: dialog_menu_child,
          hidden: true,
        }, 
        {
          path: '/instruction_group',
          name: 'ECU管理',
          component: instruction_group,
          hidden: true,
        },
        {
          path: '/instruction_list',
          name: 'ECU管理',
          component: instruction_list,
          hidden: true,
        },
        {
          path: '/faultinfo',
          name: '故障码管理',
          component: faultinfo,
          limit:'yzd_faultcode'
          // hidden: true,
        },
        {
          path: '/ecuscantype',
          name: '扫描ECU指令类型',
          component: ecuscantype,
          limit:'ecu_manage'
          // hidden: true,
        },
        {
          path: '/ecuscantyperesult',
          name: '自动扫描ECU方式的结果匹配列表',
          component: ecuscantyperesult,
          limit:'ecu_manage',
          hidden: true,
        },
        {
          path: '/logSearch',
          name: '诊断过程记录',
          component: logSearch,
          limit:'yzd_faultcode'
          // hidden: true,
        },
      ],
    },
    // {
    //   path: '/',
    //   name: '商用车在线菜单',
    //   component: content,
    //   // leaf: true, //识别只有一个节点
    //   iconCls: 'el-icon-menu',
    //   limit: 'cloud_diagnosis',
    //   children:[
    //     {
    //       path: '/menupackbrand',
    //       name: '菜单数据包',
    //       component: menupackbrand,
    //       limit:'cvmenuMG_dieselbrandmenu_page'
    //     },
    //     {
    //       path: '/dieselgroup',
    //       name: '商用车车组',
    //       component: dieselgroup,
    //       limit:'cvmenuMG_dieselgroup_page'
    //     },
    //     {
    //       path: '/dieselbrand',
    //       name: '商用车品牌',
    //       component: dieselbrand,
    //       limit:'cvmenuMG_dieselbrand_page'
    //     },
    //     {
    //       path: '/carsystem',
    //       name: '车型系统菜单',
    //       component: carsystem,
    //       limit:'cvmenuMG_dieselsysmenu_page'
    //     },
    //     {
    //       path: '/dieselecu',
    //       name: '商用车ECU',
    //       component: dieselecu,
    //       limit:'cvmenuMG_dieselecu_page'
    //     },
    //     {
    //       path: '/dieselecutype',
    //       name: '商用车ECU类型',
    //       component: dieselecutype,
    //       limit:'cvmenuMG_dieselecutype_page'
    //     },
    //     {
    //       path: '/dieseldata',
    //       name: '商用车数据',
    //       component: dieseldata,
    //       limit:'cvmenuMG_dieseldata_page'
    //     },
    //     {
    //       path: '/dieselgroupbrand',
    //       name: '车组品牌',
    //       component: dieselgroupbrand,
    //       hidden:true,
    //       limit:'cvmenuMG_dieselgroupbrand_page'
    //     },
        
    //     {
    //       path: '/dieselbrandmenu',
    //       name: '品牌系统菜单',
    //       component: dieselbrandmenu,
    //       hidden:true,
    //       limit:'cvmenuMG_dieselbrandmenu_page'
    //     },
        
    //     {
    //       path: '/authManage',
    //       name: '菜单数据包',
    //       component: authManage,
    //       hidden:true,
    //       limit:'cvmenuMG_dieselbrandmenu_page'
    //     },
    //     {
    //       path: '/authProduct',
    //       name: '菜单数据包',
    //       component: authProduct,
    //       hidden:true,
    //       limit:'cvmenuMG_dieselbrandmenu_page'
    //     },
    //     {
    //       path: '/authSystem',
    //       name: '菜单数据包',
    //       component: authSystem,
    //       hidden:true,
    //       limit:'cvmenuMG_dieselbrandmenu_page'
    //     },
    //     {
    //       path: '/menupackgroup',
    //       name: '菜单数据包车组',
    //       component: menupackgroup,
    //       hidden:true,
    //       limit:'cvmenuMG_dieselbrandmenu_page'
    //     },
    //     {
    //       path: '/sysmenulink',
    //       name: '车型系统菜单关系',
    //       component: sysmenulink,
    //       limit:'cvmenuMG_sysmenulink_page',
    //       hidden:true
    //     },
    //     {
    //       path: '/brandicon',
    //       name: '品牌图标',
    //       component: brandicon,
    //       limit:'cvmenuMG_brandicon_page'
    //     },
        
        
        
    //     {
    //       path: '/entrymask',
    //       name: '进入功能描述',
    //       component: entrymask,
    //       limit:'cvmenuMG_entrymask_page'
    //     },
    //     {
    //       path: '/polyphoneword',
    //       name: '多音字词组',
    //       component: polyphoneword,
    //       limit:'cvmenuMG_polyphoneword_page'
    //     },
    //     // {
    //     //   path: '/buildfile',
    //     //   name: '商用车菜单数据生成库文件',
    //     //   component: buildfile,
    //     //   limit:'cvmenuMG_polyphoneword_page'
    //     // },
    //   ]
    // },
    // {
    //   path: '/',
    //   name: 'F9S国内管理',
    //   component: content,
    //   // leaf: true, //识别只有一个节点
    //   iconCls: 'el-icon-menu',
    //   limit: 'f9sSys:mgr',
    //   children: [
    //     {
    //       path: '/userList',
    //       name: '用户管理',
    //       component: userList,
    //       limit: 'f9suser:list'
    //     },
    //     {
    //       path: '/carCheck',
    //       name: '诊断记录',
    //       component: carCheck,
    //       limit: 'f9scarcheck:list',
    //     },
    //     {
    //       path: '/checkDetail',
    //       name: 'checkDetail',
    //       component: checkDetail,
    //       hidden:true
    //     },
    //     {
    //       path: '/checkDetail2',
    //       name: 'checkDetail2',
    //       component: checkDetail2,
    //       hidden:true
    //     },
    //     {
    //       path: '/carInfo',
    //       name: '车辆信息',
    //       component: carInfo,
    //       limit: 'f9scarinfo:list'
    //     },
    //   ]
    // },
    // {
    //   path: '/',
    //   name: 'F9S国外管理',
    //   component: content,
    //   // leaf: true, //识别只有一个节点
    //   iconCls: 'el-icon-menu',
    //   limit: 'f9sSys:mgr',
    //   children: [
    //     {
    //       path: '/userList2',
    //       name: '用户管理',
    //       component: userList2,
    //       limit: 'f9suser:list'
    //     },
    //     {
    //       path: '/carCheck2',
    //       name: '诊断记录',
    //       component: carCheck2,
    //       limit: 'f9scarcheck:list'
    //     },
    //     {
    //       path: '/carInfo2',
    //       name: '车辆信息',
    //       component: carInfo2,
    //       limit: 'f9scarinfo:list'
    //     },
    //   ]
    // },
    {
      path: '/',
      name: 'DLL调用管理',
      limit: 'dllcallSet_mgr',
      component: content,
      // leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      children: [
      {
        path: '/dllcallSet',
        name: 'DLL调用设置',
        component: dllcallSet,
        limit: 'dllcallSet_page',
      }, 
      {
        path: '/DllcallRec',
        name: 'DLL调用记录',
        component: DllcallRec,
        hidden:true,
      }, 
      {
        path: '/DllCallInfo',
        name: 'DLL算法验证码',
        component: DllCallInfo,
        limit: 'dllcallpw_list',
        // hidden:true,
      }, 
    ]
    },
    {
      path: '/',
      name: '私有协议',
      limit: 'zd_protocol',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      children: [
      {
        path: '/privateContract',
        name: '私有协议',
        component: privateContract
      }, 
      {
        path: '/privateContract_add',
        name: '私有协议录入',
        component: privateContract_add,
        hidden: true,
      }, 
      {
        path: '/privateContract_update',
        name: '私有协议修改',
        component: privateContract_update,
        hidden: true,
      }, 
    ]
    },
    {
      path: '/',
      name: '丰汇用户',
      limit: 'fhuserManagement:list',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      children: [
      {
        path: '/fengHuiUsers',
        name: '丰汇用户',
        component: fengHuiUsers
      }, ]
    },
    {
      path: '/',
      name: '订单管理',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'orderManagement',
      children: [
      {
        path: '/order-management',
        name: '订单管理',
        limit: 'orderManagement:list',
        component: orderManagement,
        meta: {
          keepAlive: true
        },
      },
      {
        path: '/order-management/serialNum-management',
        name: '订单序列号管理',
        component: serialNumManagement,

        hidden: true,
      }, ]
    },

    {
      path: '/',
      name: '经销商管理',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'lockMachineManagement',
      children: [
      {
        path: '/lockMachineManagement',
        name: '经销商管理',
        component: lockMachineManagement
      }, ]
    },
    {
      path: '/',
      name: '业务员管理',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'salerManagement',
      children: [
      {
        path: '/salerManagement',
        name: '业务员管理',
        component: salerManagement
      }, ]
    },
    {
      path: '/',
      name: '国家/地区',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'nationalityManagement',
      children: [
      {
        path: '/nationality-management',
        name: '国家/地区',
        component: nationalityManagement
      }, ]
    },
    {
      path: '/',
      name: '注册用户',
      limit: 'memberManagement',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      children: [
      {
        path: '/member-management',
        name: '注册用户',
        component: memberManagement
      }, ]
    },
    {
      path: '/',
      name: '配件清单',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'hardListManagement',
      children: [
      {
        path: '/hardList-management',
        name: '配件清单',

        component: hardListManagement
      }, ]
    },
    {
      path: '/',
      name: '下载区域管理',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'downRegionManagement',
      children: [
      {
        path: '/downRegion-management',
        name: '下载区域管理',
        component: downRegionManagement
      }, ]
    },
    {
      path: '/',
      name: '机型（产品类型）',
      leaf: true, //识别只有一个节点
      component: content,
      iconCls: 'el-icon-menu',
      limit: 'productclassManagement',
      children: [
      {
        path: '/productclass-management',
        name: '机型（产品类型）',
        component: productclassManagement
      }, ]
    },
    {
      path: '/',
      name: '语言',
      component: content,
      leaf: true, //识别只有一个节点
      iconCls: 'el-icon-menu',
      limit: 'languageManagement',
      children: [
      {
        path: '/language-management',
        name: '语言',
        component: languageManagement
      }, ]
    },
    {
      path: '/',
      name: '拓展功能管理',
      component: content,
      leaf: true, //识别只有一个节点
      limit: 'productFunction',
      iconCls: 'el-icon-menu',
      children: [
      {
        path: '/productFunction',
        name: '拓展功能管理',
        component: productFunction
      }, ]
    },
    {
      path: '/',
      name: 'TPMS设备区域',
      component: content,
      leaf: true, //识别只有一个节点
      limit: 'e8Manager',
      iconCls: 'el-icon-menu',
      children: [
      {
        path: '/e8',
        name: 'TPMS设备区域',
        component: e8
      }, ]
    },


    // {
    //   path: '/',
    //   name: '设备激活管理',
    //   component: content,
    //   leaf: true, //识别只有一个节点
    //   iconCls: 'el-icon-menu',
    //   children: [
    //   {
    //     path: '/productActivelog',
    //     name: '设备激活管理',
    //     component: productActivelog
    //   }, ]
    // },
    // {
    //   path: '/',
    //   name: 'F8 Pro系统管理',
    //   component: content,
    //   iconCls: 'el-icon-menu',
    //   children: [
    //   {
    //     path: '/F8-pro/f8_carbrand',
    //     name: '汽车品牌',
    //     component: f8_carbrand
    //   },
    //   {
    //     path: '/F8-pro/f8_carkind',
    //     name: '车型',
    //     component: f8_carkind
    //   },
    //   {
    //     path: '/F8-pro/f8_sensortype',
    //     name: '传感器类型',
    //     component: f8_sensortype
    //   },
    //   {
    //     path: '/F8-pro/f8_reference',
    //     name: '参考值',
    //     component: f8_reference
    //   },
    //   {
    //     path: '/F8-pro/f8_sensorBrand',
    //     name: '传感器品牌',
    //     component: f8_sensorBrand
    //   },
    //   {
    //     path: '/F8-pro/f8_sensor',
    //     name: '传感器',
    //     component: f8_sensor
    //   },
    //   {
    //     path: '/F8-pro/f8_reviewUploaded',
    //     name: '审核上传数据',
    //     component: f8_reviewUploaded
    //   }]
    // },
  ]
})
router.beforeEach((to, from, next) => {
  // console.log('aaaaaaa',sessionStorage.getItem('scrollTop'))
  console.log(router.options)
  console.log(router.options.routes[3])
  router.options.routes[2].children[0].name = sessionStorage.getItem('en') ? 'Home' : '首页'
  router.options.routes[3].children[0].name = sessionStorage.getItem('en') ? 'Push Compensation Calibration' : '推车校正'
  console.log(sessionStorage.getItem('token'));
  if (sessionStorage.getItem('token')) {
    next()
  } else {
    if (to.path !== '/login') {
        next({ path: '/login' })
      // 如果没有登录，但你访问其他需要登录的页面，那我就让你跳到登录页面去
      
    }
    else {
      // 如果没有登录，但你访问的login，那就不干涉你，让你访问
      next()
      // Vue.prototype.$Permissions = JSON.parse(sessionStorage.getItem('Permissions')) || []
    }
  }
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js